import { Component, OnInit } from '@angular/core';
import { Icon } from "../../models/card-icon";
import { TableService } from "../../services/table.service";
import { UserService } from "../../services/user.service";
import { Methods } from "../../shared/methods";

@Component({
  selector: 'app-visibilitytables',
  templateUrl: './visibilitytables.component.html',
  styleUrls: ['./visibilitytables.component.css'],
  providers: [
    UserService,
    TableService,
  ],
})
export class VisibilitytablesComponent implements OnInit {
  iconVisibilityTables: Icon = {
    icon: "visibility",
    title: "Visibility Tables",
  };
  public mtds: Methods = new Methods();
  public arrayTables = [];
  public identity;
  public token;
  public tables = [
    {name: "Company Leader Board", status: 0 },
    {name: "Department Leader Board", status: 0 },
    {name: "Containers Received", status: 0 },
    {name: "Visitors at Office", status: 0 },
    {name: "Open Tickets", status: 0 },
    {name: "Custom Department Leaderboard", status: 0 },
    {name: "The Oldest 100 Containers", status: 0 },
    {name: "techList", status: 0 },
    {name: "salesList", status: 0 },
    {name: "manifestList", status: 0 },
    {name: "techBatchesList", status: 0 }
  ];


  constructor(
    private _tableService: TableService,
    private _userService: UserService,
  ) {
    this.identity = this._userService.getIdentity();
    this.token = this._userService.getToken();
   }
  handleTables() {
    this.tables.map((table) => {
      this.listTables(table.name);
    });
  }
  listTables(name) {
    let json;
    json = {
      user_id: this.identity.sub,
      name: name,
    };
    
    this._tableService.listTables(json).subscribe(
      (response) => {
        if (response.status == "success") {
          if (response.data) {
            let tableName = response.data.name;
            let tableStatus = response.data.data;
            let dataValue = JSON.parse(tableStatus);

            switch (tableName) {
              case "Visitors at Office":
                for (let i in this.tables) {
                  if (this.tables[i].name == tableName) {
                     this.tables[i].status = tableStatus;
                     break; //Stop this loop, we found it!
                  }
                }
                break;
              case "Company Leader Board":
                for (let i in this.tables) {
                  if (this.tables[i].name == tableName) {
                     this.tables[i].status = tableStatus;
                     break; //Stop this loop, we found it!
                  }
                }
                break;
              case "Department Leader Board":
                for (let i in this.tables) {
                  if (this.tables[i].name == tableName) {
                     this.tables[i].status = tableStatus;
                     break; //Stop this loop, we found it!
                  }
                }
                break;
              case "The Oldest 100 Containers":
                for (let i in this.tables) {
                  if (this.tables[i].name == tableName) {
                     this.tables[i].status = tableStatus;
                     break; //Stop this loop, we found it!
                  }
                }
                break;
              case "Open Tickets":
                for (let i in this.tables) {
                  if (this.tables[i].name == tableName) {
                     this.tables[i].status = tableStatus;
                     break; //Stop this loop, we found it!
                  }
                }
                break;
              case "Custom Department Leaderboard":
                for (let i in this.tables) {
                  if (this.tables[i].name == tableName) {
                     this.tables[i].status = tableStatus;
                     break; //Stop this loop, we found it!
                  }
                }
                break;
              case "Containers Received":
                for (var i in this.tables) {
                  if (this.tables[i].name == tableName) {
                     this.tables[i].status = tableStatus;
                     break; //Stop this loop, we found it!
                  }
                }
                break;

                case "techList":
                  for (var i in this.tables) {
                    if (this.tables[i].name == tableName) {
                       this.tables[i].status = (!dataValue || (Array.isArray(dataValue) && dataValue.length === 0)) ? 0 : dataValue;
                       break; //Stop this loop, we found it!
                    }
                  }
                  break;  
                case "salesList":
                  for (var i in this.tables) {
                    if (this.tables[i].name == tableName) {
                      this.tables[i].status = (!dataValue || (Array.isArray(dataValue) && dataValue.length === 0)) ? 0 : dataValue;
                       break; //Stop this loop, we found it!
                    }
                }
                  break;
                case "manifestList":
                    for (var i in this.tables) {
                      if (this.tables[i].name == tableName) {
                         this.tables[i].status = (!dataValue || (Array.isArray(dataValue) && dataValue.length === 0)) ? 0 : dataValue;
                         break; //Stop this loop, we found it!
                      }
                    }
                    break;
                
                case "techBatchesList":
                    for (var i in this.tables) {
                      if (this.tables[i].name == tableName) {
                          this.tables[i].status = (!dataValue || (Array.isArray(dataValue) && dataValue.length === 0)) ? 0 : dataValue;
                          break; //Stop this loop, we found it!
                        }
                      }
                      break;        
                    
              default:
                break;
            }
            // console.log(response.data)
          }
        }
        return response;
      },
      (error) => {
        // console.log("errrroooorrr");
        // this.saving = false;
        this.mtds.notifyError(error.statusText, error.status);
      }
    );
  }
  closeOpenTable(name, status) {
    let json;
    json = {
      user_id: this.identity.sub,
      name: name,
      data: status,
    };
    this._tableService.closeTable(json).subscribe(
      (response) => {
        if (response.status == "success") {
          this.handleTables();
        }
        return response;
      },
      (error) => {
        console.log("errrroooorrr");
        // this.saving = false;
        this.mtds.notifyError(error.statusText, error.status);
      }
    );
  }


  ngOnInit() {
    this.handleTables()
  }

}
